@switch (columnName) {
  @case ('name') {
    <div class="align-items-center display-flex">
      <app-ui-navigate-to-person [id]="element?.pax?.id" type="pax"></app-ui-navigate-to-person>
      {{ element.name }}
    </div>
  }
  @case ('confirm') {
    @if (element.type === paxOverviewType.Current) {
      <app-ui-button
        buttonType="icon-button"
        icon="transfer_within_a_station"
        [privilege]="Privileges.PaxOverviewUpdate"
        (click)="buttonFunctions.leave()"
      ></app-ui-button>
    } @else {
      <app-ui-button
        buttonType="icon-button"
        icon="done"
        [privilege]="Privileges.PaxOverviewUpdate"
        (click)="buttonFunctions.confirm()"
      ></app-ui-button>
    }
  }
  @case ('edit') {
    <app-ui-button
      buttonType="icon-button"
      icon="edit"
      privilege="PAX-OVERVIEW_UPDATE"
      (click)="buttonFunctions.edit()"
    ></app-ui-button>
  }
  @case ('arrivalDateTime') {
    {{ element.from | date: dateTimeFormat }}
  }
  @case ('departureDateTime') {
    {{ element.to | date: dateTimeFormat }}
  }
  @default {
    {{ element[columnName] }}
  }
}
